import React from 'react';
import './Card.css';

export interface CardProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  testID?: string;
}

/**
 * Glass-morphism card. Web equivalent of `apps/WunderGuide/common/Card.tsx`.
 * Backdrop-filter blur over translucent dark surface, 1px hairline, 20px radius.
 */
const Card: React.FC<CardProps> = ({
  children,
  className = '',
  style,
  testID,
}) => {
  const combined = `wg-card ${className}`.trim();
  return (
    <div className={combined} style={style} data-testid={testID}>
      {children}
    </div>
  );
};

export default Card;
